import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import axios from 'axios';
import cookieUtils from '../../utils/cookieUtils';

const CreateNotification = ({ show, onHide }) => {
    const [formData, setFormData] = useState({
        title: '',
        body: '',
        action_link: '',
        audience_selection: 'All', // 'All', 'Platform', 'Activity'
        platform_targets: [], // ['iOS', 'Android']
        activity_range: '', // '7', '30', '60'
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stats, setStats] = useState([]);
    const [targetUser, setTargetUser] = useState(0);

    const statusOptions = [
        'New',
        'Draft',
        'Published',
        'Success'
    ];

    const fetchStats = async () => {
        try {
            const statsData = await axios.get(`${ServerPath}/admin-notification/stats`);
            console.log('stats data', statsData)
            if (statsData.data.success === 1) {
                setStats(statsData.data.data)
                setTargetUser(statsData?.data?.data?.total_notifiable_users)
            }
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        fetchStats();
    }, [])

const handleInputChange = (e) => {
    const { name, value } = e.target;
    const sanitizedValue = value
        .replace(/^\s+/g, '')        // Prevents starting with a space
        .replace(/\s{2,}/g, ' ');    // Replaces 2+ spaces with 1 space

    setFormData(prev => ({ ...prev, [name]: sanitizedValue }));
};

    const handlePlatformChange = (platform, count) => {
        setFormData(prev => {
            const platforms = [...prev.platform_targets];
            if (platforms.includes(platform)) {
                setTargetUser(targetUser - count);
                return { ...prev, platform_targets: platforms.filter(p => p !== platform) };
            } else {
                setTargetUser(targetUser + count);
                return { ...prev, platform_targets: [...platforms, platform] };
            }
        });
    };
    
    const handleSubmit = async (status) => {
        const user = cookieUtils.getSecureCookie('user');
        if (!formData.title || !formData.body || !formData.action_link) {
            return toast.error("Please fill all required fields");
        }

        // Determine final audience_type string for DB
        let audienceType = formData.audience_selection;
        if (audienceType === 'Platform') audienceType = formData.platform_targets.join(',');
        if (audienceType === 'Activity') audienceType = `Activity-${formData.activity_range}`;

        try {
            setIsSubmitting(true);
            const payload = {
                title: formData.title,
                body: formData.body,
                action_link: formData.action_link,
                audience_type: audienceType,
                status: status, // 'Saved' or 'Published'
                created_by: user.name, // Replace with actual Admin ID
                target_user: targetUser
            };

            const res = await axios.post(`${ServerPath}/admin-notification`, payload);
            console.log('create notification response', res)
            if (res.data.success) {
                {status === 'Success'? toast.success(`Notification Published successfully`): toast.success(`Notification ${status} successfully`)}
                {status === 'Success' && toast.success(`Notification sending to ${targetUser} user`);}
                {status === 'Success' && setTimeout(() => {
                    toast.success(`Notification delivered to ${targetUser} user`);
                }, 5000);}
                onHide();
            }
        } catch (err) {
            toast.error("Failed to process notification");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontWeight: '600' }}>Create Notification Template</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '30px' }}>
                <Row>
                    {/* Left Column: Content */}
                    <Col md={7}>
                        <Form.Group className="mb-4">
                            <Form.Label>Title <span className="text-danger">*</span> <small className="text-muted">(Limit 30 chars)</small></Form.Label>
                            <Form.Control name="title" maxLength={30} value={formData.title} onChange={handleInputChange} placeholder="Enter title" />
                            <div className="text-end small text-muted">{formData.title.length}/30</div>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Text <span className="text-danger">*</span> <small className="text-muted">(Limit 100 chars)</small></Form.Label>
                            <Form.Control as="textarea" rows={4} name="body" maxLength={100} value={formData.body} onChange={handleInputChange} placeholder="Enter text" />
                            <div className="text-end small text-muted">{formData.body.length}/100</div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Action Link / URL <span className="text-danger">*</span></Form.Label>
                            <Form.Control name="action_link" value={formData.action_link} onChange={handleInputChange} placeholder="Enter Action link URL" />
                        </Form.Group>
                    </Col>

                    {/* Right Column: Targeting */}
                    <Col md={5} className="ps-5">
                        <Form.Group>
                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                Status <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                                name="status"
                                value={formData.status}
                                onChange={handleInputChange}
                                style={{
                                    height: '46px',
                                    border: '1px solid #E2E8F0',
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '6px'
                                }}
                                disabled
                            >
                                <option value="" disabled>Select status</option>
                                {statusOptions.map((option, index) => (
                                    <option key={index} value={option}>{option}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Label className="fw-bold">Target User</Form.Label>
                        <Form.Check type="radio"
                            label={`All Registered (${stats?.total_notifiable_users})`}
                            name="audience"
                            checked={formData.audience_selection === 'All'}
                            onChange={() => { setFormData({ ...formData, audience_selection: 'All', activity_range: '', platform_targets: [] }); setTargetUser(stats?.total_notifiable_users); }} />

                        <Form.Check type="radio"
                            label="By Platform" className="mt-2" name="audience"
                            checked={formData.audience_selection === 'Platform'}
                            onChange={() => { setFormData({ ...formData, audience_selection: 'Platform', activity_range: '' }); setTargetUser(0) }} />
                        <div className="ms-4">
                            <Form.Check type="checkbox"
                                label={`iOS Users (${stats?.ios_users})`}
                                checked={formData.platform_targets.includes('iOS')}
                                disabled={formData.audience_selection !== 'Platform'}
                                onChange={() => handlePlatformChange('iOS', stats?.ios_users)} />
                            <Form.Check type="checkbox"
                                label={`Android Users (${stats?.android_users})`}
                                checked={formData.platform_targets.includes('Android')}
                                disabled={formData.audience_selection !== 'Platform'}
                                onChange={() => handlePlatformChange('Android', stats?.android_users)} />
                        </div>

                        <Form.Check type="radio" label="By Activity" className="mt-2" name="audience" checked={formData.audience_selection === 'Activity'} onChange={() => { setFormData({ ...formData, audience_selection: 'Activity', platform_targets: [] }); setTargetUser(0) }} />
                        <div className="ms-4">
                            <Form.Check type="radio"
                                label={`Active in Last 7 Days (${stats?.active_notifiable_7_days})`}
                                name="act"
                                checked={formData.activity_range === '7'}
                                disabled={formData.audience_selection !== 'Activity'}
                                onChange={() => { setFormData({ ...formData, activity_range: '7' }); setTargetUser(stats?.active_notifiable_7_days) }} />
                            <Form.Check type="radio"
                                label={`Active in Last 30 Days (${stats?.active_notifiable_30_days})`}
                                name="act"
                                checked={formData.activity_range === '30'}
                                disabled={formData.audience_selection !== 'Activity'}
                                onChange={() => { setFormData({ ...formData, activity_range: '30' }); setTargetUser(stats?.active_notifiable_30_days) }} />
                            <Form.Check type="radio"
                                label={`Active in Last 60 Days (${stats?.active_notifiable_60_days})`}
                                name="act"
                                checked={formData.activity_range === '60'}
                                disabled={formData.audience_selection !== 'Activity'}
                                onChange={() => { setFormData({ ...formData, activity_range: '60' }); setTargetUser(stats?.active_notifiable_60_days) }} />
                        </div>
                        <Form.Check type="radio"
                            label="Only user with :" className="mt-2" name="audience"
                            checked={false}
                            disabled />
                        <div className="ms-4">
                            <Form.Check type="checkbox"
                                label="Location"
                                checked={false}
                                disabled />
                            <Form.Check type="checkbox"
                                label="App Version"
                                checked={false}
                                disabled />
                            <Form.Check type="checkbox"
                                label="Language preference"
                                checked={false}
                                disabled />
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="primary" style={{ backgroundColor: '#5662F6', width: '120px' }} onClick={() => handleSubmit('Draft')} disabled={isSubmitting}>Save</Button>
                <Button variant="primary" style={{ backgroundColor: '#5662F6', width: '120px' }} onClick={() => handleSubmit('Success')} disabled={isSubmitting}>Publish</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateNotification;